import React, { createContext, useContext, useEffect, useState, useMemo } from "react" 
import { Outlet, useParams, useNavigate } from "react-router-dom"
import { Pencil, ChevronRight, ChevronDown, Plus, Save, X } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { useRulesEngineCtx } from "."
import { ELEMENTS, RULES_ACTIONS } from "lib/utils"

import testdata from "./testdata.json"


const operators = [
  { label: "Must Equal", value: "eq" },
  { label: "Must Not Equal", value: "neq" },
  { label: "Must Contain", value: "contains" },
  { label: "Must Not Contain", value: "notcontains" },
  { label: "Must Exist", value: "exists" },
  { label: "Must Not Exist", value: "notexists" },
]


export default function RulesList(){

  const { engineState, updateEngineState } = useRulesEngineCtx()

  const sortedElements = useMemo( () => ELEMENTS.sort( (a:any, b:any) => {
    if( a.title < b.title ) return -1
    if( a.title > b.title ) return 1
    return 0
  }),[ ELEMENTS ])
  
  return (
    <div className="w-full flex flex-col">
      <div className="flex items-center px-2 py-1 bg-slate-800 border-b border-solid border-slate-700 text-sm">Choose a Section</div>
      { sortedElements.map( (elem:any) => (
        <div 
          key={elem.refstr} 
          className={cn(
            "text-sm px-2 py-1 cursor-pointer select-none",
            engineState.selectedSection?.refstr === elem.refstr && "bg-teal-800 text-white"
          )}
          onClick={() => updateEngineState("selectedSection", elem)}
        >
          { elem.title }
        </div>
      ))}
    </div>
  )
}